export default __webpack_public_path__ + "static/media/profit.14bae9aa.svg";